import Header from './Components/Header.js';
import Nav from './Components/Nav.js';
import Locations from './Components/Locations.js';
import Home from './Components/Home.js';
import About from './Components/About.js';
import Why from './Components/Why.js';
import Opinion from './Components/Opinion.js';
import Footer from './Components/Footer.js';
import './App.css';

function App() {
  return (
    <div className="App">
     <Header/>
     <Nav/>
     <Home/>
     <Locations/>
     <About/>
     <Why/>
     <Opinion/>
     <Footer/>
    </div>
  );
}

export default App;
